<template>
  <div>
    <tables :config="config()" />
  </div>
</template>

<script>
  export default {
    data () {
      return {
        
      }
    },
    components: {
      tables: () => import(/* webpackPrefetch: true */ '@/components/basic/table.vue')
    },
    computed: {
      
    },
    watch: {
      
    },
    mounted () {
      
    },
    methods: {
      config () {
        return {
          // CONFIG PARSING API
          api: 'site?type=contactus',

          // SINGLE
          single: false,

          // CHECKBOX
          checkbox: true,

          // PADDING
          padding: 'py-0',

          // HEIGHT
          height: true,

          // CONFIG PARSING HEADER
          header: [
            {
              text: '#No',
              width: '75px',
              value: 'index',
              sortable: false,
              freeze: true,
              hide: false,
              align: 'center'
            },
            {
              text: 'Judul',
              width: '200px',
              value: 'title',
              freeze: false,
              hide: false
            },
            {
              text: 'Deskripsi',
              width: '400px',
              value: 'content',
              freeze: false,
              hide: false,
              format: 'regex'
            },
            {
              text: 'Status',
              width: '100px',
              value: 'status',
              freeze: false,
              hide: false
            }
          ],

          // CONFIG PARSING FILTER
          filter: [],

          // PREFIX KEY
          prefix: '',

          // CONFIG PARSING FORM
          form: [
            {
              field: 'id',
              label: 'ID',
              type: 'id',
              placeholder: 'Contoh. 1',
              value: '',
              width: '20%',
              required: false,
              hide: true
            },
            {
              field: 'title',
              label: 'Judul',
              type: 'text',
              placeholder: 'Contoh. Klaten Bersinar',
              value: '',
              width: '70%',
              required: true,
              rules: 'required'
            },
            {
              field: 'content',
              label: 'Deskripsi',
              type: 'texteditor',
              placeholder: 'Contoh. Tuliskan deskripsi disini',
              value: '',
              rows: 5,
              required: false
            },
            {
              field: 'image',
              label: 'Gambar',
              type: 'image',
              placeholder: 'Contoh. https://via.placeholder.com/640x480.png/0000bb?text=images+ex',
              value: '',
              width: '100%',
              required: false
            },
            {
              field: 'type',
              label: 'text',
              type: 'select',
              placeholder: 'Contoh. Kontak Kami',
              value: 'contactus',
              hide: true
            },
            {
              field: 'status',
              label: 'Status',
              type: 'select',
              placeholder: 'Contoh. Publish',
              value: 'publish',
              option: [
                {
                  text: 'Publish',
                  value: 'publish'
                },
                {
                  text: 'Draft',
                  value: 'draft'
                }
              ],
              width: '40%',
              required: false,
              hide: false
            }
          ],

          // CONFIG PARSING ACTION
          action: {
            tab: {
              button: false,
              api: [],
              field: ''
            },
            filter: {
              button: false,
              api: ''
            },
            add: {
              text: 'Kontak Kami',
              button: true,
              api: 'site/create',
              window: false,
              href: ''
            },
            edit: {
              button: true,
              api: 'site/update',
              window: false,
              href: ''
            },
            delete: {
              button: true,
              api: 'site/delete'
            },
            detail: {
              button: false,
              api: ''
            },
            reject: {
              button: false,
              api: ''
            },
            approve: {
              button: false,
              api: ''
            },
            print: {
              button: false,
              api: ''
            },
            freeze: {
              button: false,
              api: ''
            },
            hide: {
              button: false,
              api: ''
            }
          }
        }
      }
    }
  }
</script>